<template>
  <div class="panel wraper panel-gray">
    <div class="panel-header">
      <div class="panel-title">
        <unit-path v-once :id="iniInstrument.parent_id" :lbl="lbl"></unit-path>
      </div>
    </div>
    <div class="panel-body" id="formbody">
      <q-field
        :error="$v.tempInstrument.name.$error"
        :error-label="$v.tempInstrument.name | errorLabel"
      >
        <q-input v-model.trim="tempInstrument.name" float-label="Название">
          <q-autocomplete
            :static-data="{field: 'value', list: names}"
          />
        </q-input>
      </q-field>
      <q-field>
        <q-input v-model.trim="tempInstrument.serial" float-label="Серийный номер" />
      </q-field>
      <q-field>
        <q-datetime
            float-label="Дата установки"
            clearable
            popover
            v-model="tempInstrument.dateInstall"
            :first-day-of-week="1"
            format="DD.MM.YYYY"
        />
      </q-field>
      <q-field>
        <q-input type="textarea" :rows="1"
                 v-model.trim="tempInstrument.comment" float-label="Заметки" />
      </q-field>
    </div>
    <save-btn :notChanged="notChanged" :goView="goView" :doSave="doSave" />
  </div>
</template>


<script type="text/babel">
import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';
import UnitPath from './unit-path.vue';
import SaveBtn from './save-btn.vue';

export default {
  name: 'instrumentedit',
  components: {
    UnitPath,
    SaveBtn,
  },
  data() {
    const iniInstrument = {
      name: '',
      serial: '',
      comment: '',
      dateInstall: null,
    };
    if (this.$route.name === 'unitNew') { // new instrument
      iniInstrument.parent_id = this.$route.params.parent_id;
    } else {
      Object.assign(iniInstrument, this.$store.state.units[this.$route.params.id]);
    }
    return {
      iniInstrument,
      tempInstrument: Object.assign({}, iniInstrument),
      names: [],
    };
  },
  validations: {
    tempInstrument: {
      name: {
        required: withParams({ message: 'Введите название' }, required),
      },
    },
  },
  mounted() {
    this.fetchNames();
    this.$watch('lbl', (a) => {
      document.title = a;
    }, {
      immediate: true,
    });
  },
  computed: {
    lbl() {
      if (this.addNew) {
        return '*Новый прибор*';
      }
      return this.iniInstrument.name;
    },
    notChanged() {
      return _.isEqual(this.iniInstrument, this.tempInstrument);
    },
    pid() {
      return this.iniInstrument.parent_id;
    },
    id() {
      return this.$route.params.id;
    },
    addNew() {
      return (this.$route.name === 'unitNew');
    },
  },
  methods: {
    fetchNames() {
      const self = this;
      this.$dataDB.query('utils/names', { group: true })
        .then((result) => {
          self.names = result.rows.map(row => ({ value: row.key, label: row.key }));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    doSave() {
      this.$v.tempInstrument.$touch();
      if (this.$v.tempInstrument.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      if (this.addNew) {
        const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        this.tempInstrument._id = `ins:${timestamp}${'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase()}`;
      }
      // this turn off warning
      Object.assign(this.iniInstrument, this.tempInstrument);
      this.$store.dispatch('saveUnit', this.tempInstrument)
        .then(() => {
          this.$router.jumpBack();
          // this.$router.push('/list/' + this.tempInstrument._id)
        })
        .catch(() => {
          this.$store.commit('pushError', {
            error: 'Ошибка!',
            message: 'Возможно изменения не сохранены',
          });
          this.goView();
        });
    },
    goView() {
      // this turn off warning -- removed
      // Object.assign(this.iniInstrument, this.tempInstrument);
      this.$router.jumpBack();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/instrument-edit.vue